import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateOrderItemFulfillmentInput } from './UpdateOrderItemFulfillmentInput';
import { UpdateOrderItemFulfillmentOutput } from './UpdateOrderItemFulfillmentOutput';

export class UpdateOrderItemFulfillmentService extends HttpServiceBase {

  handle = (input: UpdateOrderItemFulfillmentInput): Promise<Result<UpdateOrderItemFulfillmentOutput> | null> => {
    const promise = this.http.put<Result<UpdateOrderItemFulfillmentOutput>, UpdateOrderItemFulfillmentInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/update-order-item-fulfillment`,
      input
    );
    return promise;
  }
}